import styled from 'styled-components'

import { Colors, FontSize } from '../../../../../styles'

const Card = styled.article`
  width: 100%;
  min-height: 115px;
  max-height: 115px;
  display: flex;
  padding: 16px 24px;
  border-radius: 6px;
  flex-direction: column;
  justify-content: space-between;
  background-color: ${(props) => props.backgroundColor ? props.backgroundColor : Colors.white};
`

const CardInfoContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`

const CardInfoWrapper = styled.div`
  gap: 8px;
  display: flex;
  align-items: center;
`

const CardInfoTitle = styled.h2`
  color: ${Colors.cancelTextColor};
  margin: 0;
  font-size: ${FontSize.large}px;
`

const CardInfoSubtitle = styled.p`
  color: ${Colors.cancelTextColor};
  margin: 0;
  font-weight: 400;
  font-size: ${FontSize.medium}px;
`

const CardInfoStatus = styled.p`
  color: ${Colors.tealBlue};
  margin: 0;
  padding: 4px 24px;
  font-size: ${FontSize.medium}px;
  font-weight: 600;
  border-radius: 24px;
  box-shadow: 0px 2px 4px rgba(10, 129, 173, 0.1);
  background-color: ${(props) => props.backgroundColor ? props.backgroundColor : Colors.white};
`

const CardDetailsContainer = styled.div`
  width: 100%;
  display: grid;
  row-gap: 8px;
  column-gap: 8px;
  grid-template-columns: repeat(4, 1fr);
`

const CardDetailsText = styled.p`
  color: ${Colors.darkCharcoal};
  margin: 0;
  font-size: 13px;
  font-weight: 400;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;

  span {
    color: ${Colors.cancelTextColor};
    font-weight: 600;
  }
`

export default {
  Card,
  CardInfoTitle,
  CardInfoStatus,
  CardDetailsText,
  CardInfoWrapper,
  CardInfoSubtitle,
  CardInfoContainer,
  CardDetailsContainer,
}